import message from './message/en';
import placeholder from './placeholder/en';
let NODE_ENV = window.XINPOC_WEB_CONFIG.isProject;
let title = {
  globalpoc:"Globalpoc",
  hpyj:"Shenzhen Haopan Yijia Technology Co., Ltd.",
};
export default {
  language: {
    name: 'Chinese',
    title: 'Language',
  },
  about: {
    title: title[NODE_ENV] || 'Xin POC',
    conpanyname: 'Shenzhen Broad Information Technology Co.Ltd.',
    beian: 'Website record number',
    icp: 'Guangdong ICP No. 16086702',
    copyright: 'Copyright: Shenzhen Broad Information Technology Co.Ltd. Version number: v2.0.7 Copyright © 2021-2022'
  },
  login: {

    tag: {
      agent: 'Agent',
      company: 'Company'
    },

    placeholder: {
      account: 'Please enter the login account',
      password: 'Please enter the login password'
    },

    button: {
      login: 'login',
      remember: 'Remember the account number? '
    },

    tips: {
      empty: 'Account or password cannot be empty',
      not_account: 'Account does not exist',
      err_password: 'Password error',
      completethepuzzle: 'Drag the slider below to complete the puzzle',
      Verificationissuccessful: 'Verification is successful',
      Verificationerrorpleasetryagain: 'Verification error, please try again'
    }
  },
  from: {  //表单
    icon: 'avatar',
    Agent_name: 'Agent Name',
    Account: 'login account',
    Contact_name: 'Contact name',
    mobile: 'Mobile phone number',
    uName: 'Name',
    recharge_contact: 'Contact information for recharge',
    Select_Address: 'Select address',
    Detailed_address: 'Detailed address',
    Not_filled_in: 'not filled',
    contact_information: 'Contact information',
    area: 'area',
    Reset_Password: 'Reset password'
  },
  placeholder: {
    ...placeholder
  },
  message: { //提示
    ...message
  },
  but: {   //按钮
    send_out: 'send',
    preserve: 'Save',
    confirm: 'confirm',
    define: 'OK',
    next: 'Next'
  },

  agent: {
    Agency_account: 'Agency account',
    Contact_information: 'Contact information',
    Please_enter_agentname: 'Please enter the agent name',
    agentname_required: '(required: 4-20 characters, letters, numbers)',
    Please_enter_loginAccount: 'Please enter the login account',
    loginAccount_required: '(required: 6-20 letters, numbers)',
    Please_enter_loginPassword: 'Please enter the login password',
    loginPassword_required: '(required: 6-16 letters, numbers)',
    Please_enter_contactname: 'Please enter the contact name',
    contactname_required: '(required: 2-20 characters, letters, numbers)',
    Please_enter_address: 'Please enter the detailed address of the agent',
    address_optional: '(optional)',
    search_agent: 'Search Agent',
    recover_integer: 'The number of recovered service cards must be an integer',
    recover_num: 'The recovery number must be greater than 0'
  },

  navigation: {
    personal_center: 'Personal Center',
    search: 'Search',
    my_agent: 'My agent',
    agent_list: 'Agent List',
    create_agent: 'Create agent',

    my_company: 'My company',
    company_list: 'company list',
    create_company: 'Create company',

    my_group: 'My group',
    group_list: 'group list',
    create_group: 'Create group',

    my_user: 'My user',
    user_list: 'User List',
    create_user: 'Create user',

    news_notice: 'News Notification',
    Scanning_code_found: 'Scanning to create',

    function_card_sell: 'Service card sales',
    function_card_record: 'Service Card Record',
    system_annoucement: 'System Announcement',

    my_bounding: 'My fence',
    bounding_list: 'Bounding List',
    create_bounding: 'Create a fence',

    recording_record: 'recording record',
    sos_record: 'SOS record',
    broadcast_record: 'Broadcast record',
    Agent_details: 'Agent Details',
    Scancodetocreate: 'Scan code to create',
    Createuserinformation: 'Create user information',
    Confirmdetails: 'Confirm details',
    EditOrganizationInformation: 'Edit company information',
    notificationreminder: 'Notification reminder',
    selectgroup: 'select group',
    edituserinformation: 'edit user information',
    Userreplacementcard: 'User replacement card',
    completematerial: 'complete material',
    choosehost: 'Choose only one speaker（others mute）',
    Selectagrouptolistento: 'Select a group to listen to',
    Terminalrenewaldetails: 'Terminal renewal details',
    managementplatform: 'management platform',
    electricfence: 'electric fence',
    Electronicfencerecords: 'Electronic fence records',
    Registeraccount: "Register account",
    Boundcompanyusers:"Bound company users",
    Unboundcompanyusers:"Unbound company users",
    Listofboundcompanyusers:'List of bound company users',
    Listofunboundcompanyusers:'List of unbound company users'
  },

  setup: {
    setup: 'Setup',
    Change_Password: 'Change password',
    user_information: 'personal information',
    Reset_Login_Password: 'Reset login password',
    Modify_payment_password: 'Modify payment password',
    about: 'about',
    Problem_feedback: 'Problem Feedback',
    Verify_phone: 'Verify phone',
    Set_payment_password: 'Set payment password'
  },

  org: {
    org_name: 'company name',
    createCompany: 'New company',
    UnitAccount: 'company account',
    createGroups: 'Create 16 groups at the same time',
    plGroups: 'Batch group name suffix plus natural number, repeated name continues natural number'
  },
  consume: 'consume',
  area: 'area',
  logout: 'logout',
  VerifyPC: 'Open link on PC',
  // connect: 'Server connection exception',
  connect: 'Loading...',
  existing: 'Existing',
  individual: 'one',
  Quantityis: 'The quantity is 0 and cannot be recovered',
  Withdrawal_quantity: 'Withdrawal quantity cannot be greater than the existing quantity',
  click_load: 'Click to load more',
  refresh_successfully: 'Refresh successfully',
  search: 'Search',
  detail: 'Details',
  edit: 'edit',
  delete: 'Delete',
  confirm: 'OK',
  cancel: 'Cancel',
  call_back: 'return',
  time: 'time',
  category: 'category',
  title: 'Title',
  data: 'date',
  starting_date: 'starting date',
  ending_date: 'end date',
  starting_time: 'starting period',
  ending_time: 'End period',
  type: 'Type',
  please_select: 'Please select',
  content: 'Content',
  notice: 'Notice',
  tuneto_agent: 'Tune to agent',
  beingTransferred_agent: 'Transferred agent',
  thefence: 'fence',
  member: 'Member',
  users: 'user',
  searchuser: 'search user',
  group: 'group',
  searchgroup: 'search group',
  company: 'company',
  searchunit: 'search company',
  agent_name: 'Agent',
  prefixnickname: 'prefix nickname',
  user_name: 'Username',
  company_name: 'Affiliated company',
  user_info: 'User Information',
  sale: 'sale',
  create_user: 'Create user',
  start_service: 'Open service',
  recycle_recycled: 'recycled/recycled',
  delete_users: 'Delete users',
  deletequantity: 'delete quantity',
  purchasement: 'Purchase',
  change_agents: 'Change agents',
  voice: 'Voice',
  recording: 'recording',
  position: 'positioning',
  thefence: 'fence',
  video: 'video',
  recycle: 'Recycle',
  recycled: 'recycled',
  card_type: 'Service Card Type',
  card_type1: 'Service Card Type',
  select_card_type: 'Select service card type',
  card_number: 'Number of service cards',
  ptt_card: 'voice card',
  recording_card: 'recording card',
  gps_card: 'location card',
  sos_card: 'SOS card',
  bounding_card: 'Bounding card',
  video_card: 'video card',
  duplex_card: 'Duplex card',
  vipcard: 'VIP card',
  ptt_card_sale: 'voice card sales',
  recording_card_sale: 'Recording card sale',
  gps_card_sale: 'location card sales',
  sos_card_sale: 'SOS card sale',
  bounding_card_sale: 'Bounding card sale',
  video_card_sale: 'Video card sale',
  Duplexcardsales: 'Duplex card sales',
  vipcardsales: 'VIP card sales',
  pttgpssales: 'PTT+GPS sales',
  usevoicecard: 'use voice card',
  userecordingcard: 'use recording card',
  uselocatorcard: 'use locator card',
  useSOScard: 'Use SOS card',
  usefencecard: 'use fence card',
  usevideocard: 'use video card',
  usepttgps: 'use PTT+GPS',
  Useaduplexcard: 'Use a duplex card',
  usevipcard: 'Use VIP card',
  voiceservicecard: 'voice service card',
  recordingservicecard: 'recording service card',
  locationservicecard: 'location service card',
  SOSservicecard: 'SOS service card',
  fenceservicecard: 'fence service card',
  videoservicecard: 'Video service card',
  Dualservicecard: 'Dual service card',
  vipservicecard: 'VIP service card',
  voiceservice: 'Voice',
  recordingservice: 'recording service',
  locationservice: 'location service',
  SOSservice: 'SOS service',
  fenceservice: 'fence service',
  videoservice: 'Video service',
  duplexservice: 'Duplex service',
  recordingcardrecycling: 'Recording card recycling',
  LocationCardRecycling: 'Location Card Recycling',
  SOSCardRecycling: 'SOS Card Recycling',
  FenceCardRecycling: 'Fence Card Recycling',
  videocardrecycling: 'Video card recycling',
  Duplexcardrecycling: 'Duplex card recycling',
  VoiceFeatureNotification: 'Voice Feature Notification',
  Notificationofrecordingfunction: 'notification of recording function',
  Positioningfeaturenotification: 'Positioning feature notification',
  SOSfunctionnotification: 'SOS function notification',
  Fencefeaturenotification: 'Fence feature notification',
  VideoFeatureNotification: 'Video Feature Notification',
  DuplexFeatureNotification: 'Duplex function notification',
  PTTGPSFeatureNotification: 'PTT+GPS Feature Notification',
  automatically: 'Automatically delete test user notifications',
  DeleteExpired: 'Delete expired user notification',
  remained: 'Balance',
  pieces: 'piece ',
  residue: 'residual',
  recycle_successfully: 'Recycle successfully',
  None_record: 'No record yet',
  this_month: 'this month',
  Year: 'Year',
  moon: 'month',
  day: 'day',
  weekly1: 'Monday',
  weekly2: 'Tuesday',
  weekly3: 'Wednesday',
  weekly4: 'Thursday',
  weekly5: 'Friday',
  weekly6: 'Saturday',
  weekly7: 'Sunday',
  submit: 'Submit',
  modify_successfully: 'Modified successfully',
  confirm1: 'Confirm',
  lumpsum: 'total',
  selltoagents: 'sell to agents',
  nametips: 'The input nickname is just the prefix of the user nickname, and the suffix is distinguished by a natural number according to the number of users you created. For example: the nickname you entered is',
  nametips2: 'The nicknames of the two users you created are',
  nametips3: 'Next time',
  nametips4: 'For the nickname prefixed, the user name will be extended to',
  nametips5: 'wait',
  IMEIscancodetoadd: 'IMEI scan code to add',
  IMEIinputadded: 'IMEI input added',
  IMEIinputaddedtocreate: 'IMEI input added to create up to 10 users',
  Starttherecordingservice: 'Start the recording service',
  Turnonlocationservices: 'Turn on location services',
  EnableSOSservice: 'Enable SOS service',
  Startfenceservice: 'Start fence service',
  Turnondualservice: 'Turn on dual service',
  Turnonthevideoservice: 'Turn on the video service',
  Usercomments: 'User comments',
  Agentnote: 'Agent note',
  total: 'total',
  settlement: 'Settlement',
  hint: 'hint',
  Areyousuretoremove: 'Are you sure to remove? ',
  Areyousuretoclearall: 'Are you sure to clear all? ',
  cocreated: 'co-created',
  accountssubtotal: 'accounts, subtotal',
  Scancodeentryarea: 'Scan code entry area',
  empty: 'empty',
  none: 'none',
  Second: 'seconds',
  Salesvolume: 'Sales Volume',
  Purchasequantity: 'Purchase Quantity',
  returnquantity: 'return quantity',
  Recoveredquantity: 'recovered quantity',
  returnquantity2: 'return quantity',
  setasdefaultgroup: 'Set as default group',
  newgroup: 'New group',
  groupname: 'group name',
  selected: 'selected',
  groups: 'groups',
  allgroups: 'all groups',
  Groupduration: 'Group duration',
  calltime: 'call time',
  groupmembers: 'group members',
  Modifygroupname: 'Modify group name',
  priority: 'priority',
  remove: 'remove',
  addmembers: 'Add members',
  levelone: 'level 1',
  Secondary: 'level 2',
  Levelthree: 'level 3',
  Levelfour: 'level 4',
  Fifthgrade: 'level 5',
  OKtoadd: 'OK to add',
  reenter: 're-enter',
  Setdigitservicecardpassword: 'Set 6-digit service card password',
  Enteragaintoconfirm: 'Enter again to confirm',
  Enterthedigitservicecardpassword: 'Enter the 6-digit service card password',
  consumptioncard: 'consumption card',
  ConsumeSOScard: 'Consume SOS card',
  Consumefencecard: 'Consumefence card',
  Consumptionrecordingcard: 'Consumptionrecording card',
  Consumeduplexcard: 'Consumeduplex card',
  Consumptionvideocard: 'Consumption video card',
  account: 'account',
  unfilled: 'unfilled',
  contactnumber: 'contact number',
  emailaddress: 'Email address',
  mailingaddress: 'mailing address',
  Belonginggroup: 'Belonging group',
  Nickname: 'User name',
  suspendaccount: 'Account',
  unitdispatcher: 'company dispatcher',
  dispatcher: 'dispatcher',
  basestationpositioning: 'base station positioning',
  GPSlocation: 'GPS location',
  positioninginterval: 'positioning interval',
  videocall: 'video call',
  strongpullvideo: 'Strong pull video',
  videoreturn: 'Video return',
  Numberchangeperiod: 'Number change period',
  UsersNickname: "User's Nickname",
  volumeactivation: 'Batch activation',
  batchselection: 'batch selection',
  searchhistory: 'Search History',
  returnnotice: 'return notification',
  Notificationofbeingwithdrawn: 'Notificationofbeingwithdrawn',
  takebacknotice: 'takeback notice',
  bouncenotification: 'Bounce notification',
  Notificationofbeingreturned: 'Notification of being returned',
  Createusernotification: 'Create user notification',
  purchasenotice: 'Purchase notification',
  salereminder: 'sale reminder',
  today: 'today',
  yesterday: 'Yesterday',
  thedaybeforeyesterday: 'the day before yesterday',
  OriginalIMEI: 'Original IMEI',
  NewIMEI: 'New IMEI',
  replace: 'replace',
  verificationcode: 'verification code',
  resendverificationcode: 'resend verification code',
  back: 'back',
  host: 'only one speaker（others mute）',
  listeninggroup: 'listening group',
  Addlisteninggroup: 'Add listening group',
  Nodata: 'No data',
  Corenewal: 'Total renewal fee',
  Accountssubtotal: 'accounts, subtotal',
  Confirmrenewal: 'Confirm renewal',
  add_groupname_tips: 'Add a natural number to the suffix of the batch group name, and continue the natural number for repeated names',
  Dataloadingcomplete: 'Data loading complete',
  Usercreatedgroups: 'User-created groups',
  Lord: 'Group leader',
  chooseagroupleader: 'Choose a group leader',
  alluser: 'all user',
  SOSalarmsintemporarygroupsarenotrecorded: 'SOS alarms in temporary groups are not recorded.',
  username: 'user name',
  startingtime: 'starting time',
  Processor: 'Processor',
  processtime: 'process time',
  Unprocessed: 'Unprocessed',
  Processed: 'Processed',
  deleted: 'deleted',
  name: 'name',
  address: 'address',
  Warmreminder: 'Warm reminder: The data comes from a third party and may contain errors. It is for reference only.',
  SOSlocation: 'SOS location',
  permanent: 'permanent',
  Latitudeandlongitude: 'Latitude and longitude',
  Reportingtime: 'Reporting time',
  Positioningtime: 'Positioning time',
  op1: 'ON',
  op2: 'OFF',
  groupban: 'Group mute',
  setptt: 'Set PTT service period',
  Determinethemodification: 'Determine the modification',
  Onemonth: 'One month',
  Threemonths: 'Three months',
  Halfayear: 'Half a year',
  Expiredate: 'Expire date',
  year1: 'One year',
  year2: 'Two years',
  year3: 'Three years',
  Sun: 'Sun',
  Mon: 'Mon',
  Tue: 'Tue',
  Wed: 'Wed',
  Thu: 'Thu',
  Fri: 'Fri',
  Sat: 'Sat',
  Membermanagement: 'Member management',
  Validpermanently: 'Valid permanently',
  Enteralarm: 'Enter alarm',
  Leavealarm: 'Leave alarm',
  repeat: 'repeat',
  Updatefence: 'Update fence',
  Triggermode: 'Trigger mode',
  Validperiod: 'Valid period',
  start: 'start',
  end: 'end',
  Validdate: 'Valid date',
  fencekeeper: 'fence keeper',
  Membermanagement: 'Member management',
  fencename: 'fence name',
  Editfence: 'Edit fence',
  Setupafencemanager: 'Set up a fence manager',
  Fencedetails: 'Fence details',
  Currentoutofboundsrecord: 'Current out-of-bounds record',
  Historicalcrossborderrecords: 'Historical cross-border records',
  Allfences: 'All fences',
  Triggertime: 'Trigger time',
  Releasetime: 'Release time',
  NoExit: 'No Exit',
  NoEntry: 'No Entry',
  Recordinglist: 'Recording list',
  temporarygroup: 'temporary group',
  Voicelicensetype: 'Voice license type',
  Voicelicensetime: 'Voice license time',
  UTCtimeTips: 'The expiry time is UTC time',
  Determinethereplacement: 'Determine the replacement',
  Regionalreplacement: 'Regional replacement',
  Recoverypassword: 'Recovery password',
  usertype: 'User type',
  Singlefunctioncarduser: 'Single function card user',
  vipcarduser: 'VIP card user',
  PTTGPS: 'PTT+GPS',
  PTTGPSuser: 'PTT+GPS user',
  display: 'Show user name',
  Service_card_display: 'Service card display',
  RequiredvoiceserviceorVIPservice: 'Required PTT service or VIP service',
  is_card: {
    ptt: 'PTT',
    recording: 'Recording',
    gps: 'GPS',
    sos: 'SOS',
    bounding: 'Bounding',
    duplex: 'Duplex',
    vip: 'Vip'
  },
  Dispatcherrole: 'Dispatcher role',
  show: 'show ',
  point: 'Point-to-point call',
  IMEIchange: 'IMEI change',
  Register:"Register",
  Bindingdevice:"Binding device",
  Notactivated:"Not activated",
  Platformcreation:"Platform creation",
  Userregistration:"User registration",
  Binding:"Binding",
  Notenabled:"Not enabled",
  Unbinding:"Unbinding",
  userPatrol:{
    PatrolCard: "Patrol card",
    Patrol: "Patrol",
    DisplayPatrolCard: "Display patrol card",
    GuardCardRecycling: "Patrol card recycling",
    patrolService:"Patrol service",
    ConsumePatrolCards: "Consume patrol cards",
    StartPatrolService: "Start patrol service",
    YourPatrolCardIsInsufficientPleaseRecharge: "Your patrol card is insufficient, please recharge!",
    UsingPatrolCards: "Use patrol card",
    PatrolCardBalanceInsufficient: "Patrol card balance insufficient",
    PatrolServiceCard: "Patrol Service Card",
    PatrolCardSales: "Patrol card sales",
    PatrolFunctionNotification: "Patrol Function Notification",
    PatrolManagement: "Patrol Management",
    PatrolPlan: "Patrol Plan",
    ExecuteTheTask: "Execute the task",
    PatrolReport: "Patrol Report",
    SearchPlan: "Search Plan",
    Suspended: "Suspended",
    Enabled: "Enabled",
    NewPlans: "New plans",
    TerminalReminderSettings: "Terminal reminder settings",
    ReminderRules: "Reminder Rules",
    ReminderTime: "Reminder Time",
    NumberOfReminders: "Number of reminders",
    minute: "minute",
    note1:"Note:If the patrol start reminder time is set to30Minutes, reminding users2Next time. Then, the users participating in the patrol will...30Received the first minute1A message reminder will be sent before the start.15Received the first minute2The number of message notifications will be counted, and so on.",
    PleaseEnterTheReminderTime: "Please enter the reminder time.",
    PleaseEnterTheNumberOfReminders:"Please enter the number of reminders.",
    PleaseEnterANumberGreaterThanOrEqualTo20: "Please enter a number greater than or equal to 20.",
    PleaseEnterANumberLessThanOrEqualTo5: "Please enter a number less than or equal to 5.",
    OperationSuccessful: "Operation successful",
    NewPatrolPlan: "New patrol plan",
    PleaseEnterThePlanName: "Please enter the plan name.",
    UsersWhoNeedPatrols: "Users who need patrols",
    OnlyRegularUsersWhoHaveActivatedThePatrolServiceCanPerformPatrols: "Only regular users who have activated the patrol service can perform patrols.",
    EffectiveDateOfThePlan: "Effective date of the plan",
    PlannedStatus: "Planned status",
    Week: "Week",
    DailyPatrolTime: "Daily patrol time",
    TaskGenerationTime: "Task generation time",
    AutomaticallyGenerateTheTimeForTheNextDaysScheduledTasksEveryDay:"Automatically generate the time for the next day's scheduled tasks every day.",
    patrolPoint:"patrol point",
    save:"save",
    TheProjectNameAlreadyExists:"The project name already exists.",
    TheNameConsistsOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:"The name consists of 1 to 50 characters, including Chinese characters, numbers, letters, and special symbols.",
    PleaseSelectTheUserWhoNeedsToBePatrolled:"Please select the user who needs to be patrolled.",
    PleaseSelectTheEffectiveDateOfThePlan:"Please select the effective date of the plan.",
    PleaseSelectDailyPatrolTime: "Please select daily patrol time.",
    TheEndTimeMustBeGreaterThanTheStartTime: "The end time must be greater than the start time.",
    PleaseSelectTheTaskGenerationTimeForTheNextDay: "Please select the task generation time for the next day.",
    PleaseAddPatrolPoints: "Please add patrol points.",
    PatrolUsers:"Patrol users",
    AddUser: "Add user",
    ConfirmAdd: "Confirm Add",
    PleaseSelectTheUserYouWishToAdd: "Please select the user you wish to add.",
    UserAddedSuccessfully:"User added successfully",
    AddTo: "Add to",
    PatrolPointNames:"Patrol Point Names",
    PleaseEnterThePatrolPointName:"Please enter the patrol point name.",
    RequiredTheNameMustConsistOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols: "(Required: The name must consist of 1 to 50 characters, including Chinese characters, numbers, letters, and special symbols)",
    NFCNumber: "NFC number",
    PleaseEnterYourNFCNumber: "Please enter your NFC number.",
    Required150Characters:"(Required: 1-50 characters)",
    ThePatrolPointNameAlreadyExists: "The patrol point name already exists.",
    TheNameConsistsOf150CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols: "The name consists of 1-50 characters, including Chinese characters, numbers, letters, and special symbols.",
    Remark: "Remark",
    NoteWithin100Characters: "Note: Within 100 characters",
    CreationSuccessful: "Creation successful",
    EditorsPatrolPoint: "Editor's patrol point",
    save1: "save",
    ModificationSuccessful: "Modification successful",
    delete: "delete",
    Remove: "Remove",
    AreYouUreYouWantToDeleteThisPatrolPoint: "Are you sure you want to delete this patrol point?",
    DeletionSuccessful: "Deletion successful",
    EditorsPatrolPlan: "Editor's Patrol Plan",
    PatrolPlanDetails: "Patrol Plan Details",
    AreYouSureYouWantToSuspendThePlanIfSuspendedTodaysScheduledPatrolsWillBeCancelled: "Are you sure you want to suspend the plan? If suspended, today's scheduled patrols will be cancelled.",
    OperationSuccessful1: "Operation successful",
    PleaseSelectTime: "Please select time",
    FullPlan: "Full Plan",
    AllUsers:"All users",
    ProjectName:"Project Name",
    PatrolUsers1: "Patrol users",
    PatrolTime: "Patrol Time",
    NotStarted: "Not started",
    inProgress: "in progress",
    Completed: "Completed",
    MissedInspection: "Missed inspection",
    PleaseEnterYourUsername: "Please enter your username.",
    ExecutionDetails: "Execution details",
    PatrolPointNames1: "Patrol Point Names",
    PatrolYype: "Patrol type",
    ExecutionResult: "Execution result",
    position: "position",
    NFC: "NFC",
    Bluetooth: "Bluetooth",
    PleaseSelectPatrolUser: "Please select patrol user",
    DailyStatistics: "Daily statistics",
    WeeklyStatistics: "Weekly statistics",
    MonthlyStatistics: "Monthly statistics",
    time: "time",
    NumberOfPlannedExecutions: "Number of planned executions",
    ActualNumberOfExecutions: "Actual number of executions",
    NumberOfMissedInspections: "Number of missed inspections",
    CompletionRate: "Completion rate",
    PleaseEnterYourUsername : "Please enter your username.",
    Existing: "Existing",
    NewPatrolPoints:"New patrol points"
  },
  Reclaim: "Reclaim",
  minute: "minute",
}
